import React from 'react'

const pureLayout = ({ children }) => (
  <div className='pure-layout'>
    {children}
  </div>
)

export default pureLayout
